import clsx from 'clsx'

/**
 * TranscriptToggle button for opening/closing the transcript panel
 *
 * @param {boolean} isOpen - Whether the transcript panel is open
 * @param {Function} onClick - Click handler
 * @param {boolean} isPanelOpen - Whether panel is currently open (changes button appearance)
 * @param {string} className - Additional CSS classes
 */
export default function TranscriptToggle({
  isOpen = false,
  onClick,
  isPanelOpen = false,
  className,
}) {
  return (
    <button
      className={clsx(
        'fixed top-1/2 -translate-y-1/2 w-10 h-[60px]',
        'bg-glass-bg backdrop-blur-[10px] border border-glass-border',
        'cursor-pointer hidden items-center justify-center',
        'text-[1.2rem] text-text-primary transition-all duration-300 z-[91]',
        'hover:bg-primary-gradient',
        // When panel is closed
        !isPanelOpen && 'right-5 rounded-l-[20px] border-r-0 hover:-translate-y-1/2 hover:-translate-x-0.5',
        // When panel is open
        isPanelOpen && 'right-[400px] rounded-r-[20px] border-l-0 border-r max-[1400px]:right-[340px]',
        // Responsive - hide on tablet and below
        'max-lg:hidden',
        // Mobile debugging
        'max-md:bottom-[100px] max-md:top-auto max-md:translate-y-0',
        className
      )}
      onClick={onClick}
      title="Toggle Transcript"
    >
      <span>{isPanelOpen ? '✕' : '💬'}</span>
    </button>
  )
}
